/**
 * Created by mark on 05/03/2018.
 */


import React  from 'react';
import Wizard from '../wizards/wizard.js';
import {SelectActivities, Comfirmation} from '../wizards/assignments';


export default class AssignmentWizard extends React.Component {

    constructor(props) {
        let Steps = [SelectActivities,Comfirmation];
        super(props);
        this.state = {steps:Steps, names:undefined}
    }

    onModify(steps, names){
        this.setState({steps:steps, names:names});
    }

    render() {
        return <div>
            <Wizard onModify={this.onModify.bind(this)} names={this.state.names} name="" stepsNavigation={true} steps={this.state.steps} />
        </div>;
    }

}


